var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14145 35.8095L0.216797 0.0668945L35.1448 0.138722L32.0523 35.8095L17.8126 39.9327L3.14145 35.8095Z",
    fill: "#1B73BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 36.481V3.47119L32.1961 3.51908L29.6311 33.053L17.8125 36.481Z",
    fill: "#1C88C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6242 7.69043H6.49756L7.09697 12.0052H17.5968L7.26485 16.4402L7.86398 20.6113H23.0867L22.5351 26.4363L17.381 27.4433L12.7066 26.2448L12.3469 22.9365H8.0558L8.63098 29.8168L17.8365 32.3817L26.6586 29.577L27.7853 16.1284H18.4596L28.6239 11.9094L28.6242 7.69043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.928,
    height: 40,
    fill: "white",
    transform: "translate(0.216797)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css-3.98ae5842bc1376662cdc63785ea39ac2.svg";
export { ForwardRef as ReactComponent };